import React, { useState } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import TFUSelect from "../based/inputs/TFUSelect";
import TextArea from "../based/inputs/TextArea";
import FinanceServices from "../based/services/FinanceServices";
import { Notify } from "../based/Notify";
import { NOTIFY } from "../based/Constants";

const ReasonOptions = [
    {
        label: "Số tài khoản chưa đúng/không hợp lệ",
        value: 0,
    },
    {
        label: "Partner vi phạm chính sách",
        value: 1,
    },
    {
        label: "Lỗi hệ thống/ngân hàng",
        value: 2,
    },
    {
        label: "Lý do khác",
        value: 3,
    },
];

function PostponeModal({ show, onClose, walletId, onSave }) {
    const [model, setModel] = useState({ reasonType: 0, note: "" });

    const updatePostpone = async (model) => {
        const [err, data] = await FinanceServices.UpdatePostponeTicket({ ...model, id: +walletId });
        if (!err && data) {
            onSave();
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra, vui lòng thử lại sau.");
        }
    };

    return (
        <CommonModal
            show={show}
            size="md"
            title="Tạm hoãn chuyển tiền"
            onClose={onClose}
            hideOnClose
            customButton={
                <div className="lst-button">
                    <button
                        className="btn btn-danger mx-2"
                        onClick={(e) => {
                            onClose();
                        }}
                    >
                        Đóng
                    </button>
                    <button
                        className="btn btn-purple mx-2"
                        onClick={(e) => {
                            updatePostpone(model);
                        }}
                    >
                        Tạm hoãn
                    </button>
                </div>
            }
        >
            <Wrapper>
                <div className="form-group">
                    <TFUSelect value={model.reasonType} onChanged={(value) => setModel({ ...model, reasonType: value })} options={ReasonOptions} />
                </div>
                <div className="form-group">
                    <TextArea value={model.note} onChanged={(name, value) => setModel({ ...model, note: value })} />
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default PostponeModal;

const Wrapper = styled.div``;
